import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M11.452 4.277c.4.11.634.523.524.922l-2.753 10a.75.75 0 1 1-1.446-.398l2.753-10a.75.75 0 0 1 .922-.524M6.488 5.931a.75.75 0 0 1 .081 1.057L3.988 10l2.581 3.012a.75.75 0 1 1-1.138.976l-2.889-3.37a.95.95 0 0 1 0-1.236l2.889-3.37a.75.75 0 0 1 1.057-.081m-2.807 4.427L3.263 10zm9.83-4.427a.75.75 0 0 1 1.058.081l2.889 3.37a.95.95 0 0 1 0 1.236l-2.889 3.37a.75.75 0 0 1-1.138-.976L16.012 10l-2.581-3.012a.75.75 0 0 1 .08-1.057"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCode;
